import { useParams } from 'react-router-dom'

export default function ProductPage() {
  const { id } = useParams<{ id: string }>()
  return <h1>Viewing Product ID: {id}</h1>
}
